import { cn } from '@/lib/utils';

/**
 * Small, on-theme pill labelling a unit's GPS location source
 * (Starlink | Omni | Manual). Label-only with neutral design tokens — no
 * per-source colors, per the site-theme convention. Renders nothing when the
 * source is absent/unknown, so callers can drop it in unconditionally.
 */
const SOURCE_LABELS: Record<string, string> = {
  starlink: 'Starlink',
  omni: 'Omni',
  manual: 'Manual',
};

export function LocationSourceBadge({
  source,
  className,
}: {
  source?: string | null;
  className?: string;
}) {
  if (!source) return null;
  const label = SOURCE_LABELS[source] ?? source;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border border-border bg-muted px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-muted-foreground',
        className,
      )}
    >
      {label}
    </span>
  );
}
